import { HTMLAttributes, memo } from 'react';
import classNames from 'classnames';
import styles from './Dot.module.scss';

export type DotProps = {
    color: string;
    size?: 'small' | 'medium' | 'large';
    margins?: boolean;
} & HTMLAttributes<HTMLDivElement>;

const Dot = ({
    color,
    margins = true,
    size = 'medium',
    style,
    ...props
}: DotProps) => (
    <div
        className={classNames(styles.dot, styles[size], {
            [styles.noMargins]: !margins,
        })}
        style={{ backgroundColor: color, ...style }}
        {...props}
    />
);

export default memo(Dot);
